import { createIcon } from './createIcon';

/**
 * Model — a cube. The shape the rest of the app already uses for a model (see
 * the composer's picker), so the nav and the picker agree.
 */
export const ModelIcon = createIcon({
  name: 'ModelIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <path
        d="M8 1.75 13.75 5v6L8 14.25 2.25 11V5L8 1.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M2.4 5 8 8.15 13.6 5M8 8.15v6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </>
  ),
});

export default ModelIcon;
